import { inject, Injectable } from '@angular/core';
import { ConfigFacade } from '@rx-applications/clientsite/shared/config/data-access';
import { AuthApiFacade } from '@rx-applications/shared/auth/api';
import { map } from 'rxjs';

// This resolver it is necessary because AuthFacade needs to be fully migrated to the shared folder
@Injectable({ providedIn: 'root' })
export class CompanyPaymentResolver {
  #configFacade = inject(ConfigFacade);
  #authApiFacade = inject(AuthApiFacade);
  resolve() {
    return this.#configFacade.selectCompanyPaymentData$.pipe(
      map((data) => ({
        ...data,
        email: this.#authApiFacade.getTokenEmail(),
      }))
    );
  }
}
